import { FC } from 'react'
import DatePicker from 'react-datepicker'
import DropDown from '../../DropDown/DropDown'
import { Calendar } from '../../CustomCalendar/components'
import { format } from 'date-fns'
import styles from '../EditClaimCardMainInformation.module.css'

interface DateTimePickerProps {
  label: string
  dateString: string
  time: Date | null
  selectedDate: Date
  isOpenDate: boolean
  isOpenTime: boolean
  dateRef: React.RefObject<HTMLDivElement>
  timeRef: React.RefObject<HTMLDivElement>
  onDateClick: (e: React.MouseEvent) => void
  onTimeClick: (e: React.MouseEvent) => void
  onDateChange: (date: Date) => void
  onTimeChange: (time: Date | null) => void
  setFieldValue: (field: string, value: any) => void
  dateField: string
  timeField: string
  placeholder: string
  customInput: JSX.Element
}

export const DateTimePicker: FC<DateTimePickerProps> = ({
  label,
  dateString,
  time,
  selectedDate,
  isOpenDate,
  isOpenTime,
  dateRef,
  timeRef,
  onDateClick,
  onTimeClick,
  onDateChange,
  onTimeChange,
  setFieldValue,
  dateField,
  timeField,
  placeholder,
  customInput,
}) => {
  return (
    <div className={styles.dateAndTimeBlock}>
      <div className={styles.leftBlock}>{label}</div>
      <div className={styles.rightDateBlock}>
        <div className={styles.containerTime}>
          <div
            onClick={onDateClick}
            style={dateString ? { color: 'black' } : { color: 'rgba(120, 120, 120, 1)' }}
            className={styles.dateValue}
          >
            {dateString ? dateString : placeholder}
            <DropDown ref={dateRef} className={styles.dropDown} open={isOpenDate}>
              <Calendar
                selectedDate={selectedDate}
                selectDate={(date) => {
                  onDateChange(date)
                  setFieldValue(dateField, format(date, 'dd.MM.yyyy'))
                }}
                disableDayRestrictions={true}
              />
            </DropDown>
          </div>
          <div className={styles.timeLeftBlock}>
            <div className={styles.dateBlock} onClick={onTimeClick}>
              <div className={styles.dateBlock}>
                <DatePicker
                  showTimeSelect
                  showTimeSelectOnly
                  selected={time}
                  onChange={(time: Date | null) => {
                    onTimeChange(time)
                    if (time) {
                      const hours = time.getHours().toString().padStart(2, '0')
                      const minutes = time.getMinutes().toString().padStart(2, '0')
                      setFieldValue(timeField, `${hours}:${minutes}`)
                    } else {
                      setFieldValue(timeField, '')
                    }
                  }}
                  timeFormat='HH:mm'
                  dateFormat='HH:mm'
                  timeIntervals={15}
                  timeCaption='Time'
                  customInput={customInput}
                  placeholderText='Время'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
